import { AbstractControl, FormArray, FormBuilder, FormGroup, FormGroupDirective, NgForm, ValidatorFn, Validators } from '@angular/forms';
import { Component, Input, OnInit } from '@angular/core';
import { DataSourceTypeFieldValidator } from '@shared/validators/data-source-type-field-validator';
import { Fields } from '@app/services/selective-processes/fields/fields';
import { FormControl } from '@angular/forms';
import { ErrorStateMatcher, MatRadioChange } from '@angular/material';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import {
  IntegrationPredefinedFields
} from '@app/services/selective-processes/component/button-settings/integration-predefined-fields/integration-predefined-fields';

export class FormCustomValidators {
  static valueSelected(myArray: any[]): ValidatorFn {

    return (c: AbstractControl): { [key: string]: boolean } | null => {
      const selectboxValue = c.value?.label;
      const pickedOrNot = myArray.filter(alias => alias.label === selectboxValue);
      if (c.parent) {
        if (c.value) {
          if (pickedOrNot.length > 0) {
            return null;
          } else {
            return { match: true };
          }
        } else {
          return null;
        }
      }
    };
  }
}

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || isSubmitted));
  }
}

@Component({
  selector: 'app-fields-related-to-button-integration',
  templateUrl: './fields-related-to-button-integration.component.html',
  styleUrls: ['./fields-related-to-button-integration.component.scss']
})
export class FieldsRelatedToButtonIntegrationComponent implements OnInit {

  @Input() formGroup: FormGroup;
  @Input() controlForm: FormArray;
  @Input() systemFields: Fields[] = [];
  @Input() predefinedFieldsCielo: IntegrationPredefinedFields[] = [];

  public matcher = new MyErrorStateMatcher();

  public filteredSystemFieldOptions: Observable<Fields[]>[] = [];

  constructor(private formBuilder: FormBuilder) { }

  ngOnInit(): void {
    this.predefinedFieldsCielo.map((value) => {
      this.controlForm.push(this.createItem(value));
      this.manageNameControl(this.controlForm.length - 1);
    });
  }

  createItem(cieloField): FormGroup {
    return this.formBuilder.group({
      id: cieloField.id ? cieloField.id : null,
      cielo_integration_id: cieloField.cielo_integration_id ? cieloField.cielo_integration_id : null,
      cielo_field_id: cieloField.cielo_field_id,
      title: cieloField.title,
      is_required: cieloField.is_required,
      identifier: cieloField.identifier,
      field_type: cieloField.field_type,
      parameter_type_id: [
        cieloField.parameter_type_id ? cieloField.parameter_type_id : null,
        cieloField.is_required === 1 ? Validators.required : null
      ],
      field_id: [
        this.searchTheCompleteFieldData(cieloField.field_id ? cieloField.field_id : ''),
        this.setValidationWithFieldIdIfRequired(cieloField.is_required)
      ],
      fixed_value: [
        cieloField.fixed_value ? cieloField.fixed_value : '',
        this.setValidationWithFixedValueIfRequired(cieloField.is_required)
      ]
    });
  }

  private uncheckRadio(control) {
      control.get('parameter_type_id').reset();
      control.get('field_id').reset();
      control.get('fixed_value').reset();
  }

  private setValidationWithFieldIdIfRequired(isRequired) {
    if (isRequired === 1) {
      return [DataSourceTypeFieldValidator.valueFieldId(), FormCustomValidators.valueSelected(this.systemFields)];
    } else {
      return [FormCustomValidators.valueSelected(this.systemFields)];
    }
  }

  private setValidationWithFixedValueIfRequired(isRequired) {
    if (isRequired === 1) {
      return [DataSourceTypeFieldValidator.valueFixedValue()];
    } else {
      return [];
    }
  }

  manageNameControl(index: number) {
    this.filteredSystemFieldOptions[index] = this.controlForm.at(index).get('field_id').valueChanges
      .pipe(
        startWith(''),
        map(option => option ? this.systemFieldOptionsFilter(option) : this.systemFields.slice())
      );
  }

  parameterTypeChanges() {
    this.controlForm.controls.forEach(control => {
      const controlAny: any = control;
      controlAny.controls.fixed_value.updateValueAndValidity();
      controlAny.controls.field_id.updateValueAndValidity();
    });
  }

  private searchTheCompleteFieldData(fieldId) {
    if (typeof fieldId !== 'object') {
      if (this.systemFields && this.systemFields.length) {
        for (const iterator of this.systemFields) {
          if (iterator.field_id === fieldId) {
            return iterator;
          }
        }
      }
      return null;
    } else {
      return fieldId;
    }
  }

  systemFieldOptionsFilter(value: string): Fields[] {
    if (typeof value === 'string') {
      const filterValue = value.toLowerCase();
      return this.systemFields.filter(option =>
        option.label.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').match(filterValue)).sort((a, b) => {
          if (a.label.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '') <
            b.label.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')) {
            return -1;
          } else if (a.label.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '') >
            b.label.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')) {
            return 1;
          } else {
            return 0;
          }
        });
    } else {
      return [];
    }
  }

  displayFn(field?: Fields): string | undefined {
    return field ? field.label : undefined;
  }

}
